export default __webpack_public_path__ + "static/media/blood-glucose.1530520d.svg";